import { trackForwardedComponent } from '../../util/trackComponent.js';
import { GridItem as GridItemMemoized } from './GridItem.js';
export { GridItemStyled } from './GridItem.js';

var GridItemWithTracking = trackForwardedComponent(GridItemMemoized);

export { GridItemWithTracking as GridItem };
//# sourceMappingURL=externalGridItem.js.map
